import { render } from "./paymentpolicy.vue?vue&type=template&id=7673ef24"
import script from "./paymentpolicy.vue?vue&type=script&lang=js"
export * from "./paymentpolicy.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__